var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "url(#paint0_linear_4_21)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.366 51.7073C108.329 51.7073 110.732 54.1097 110.732 57.0732V80.4878H128.78V57.0732C128.78 54.1097 131.183 51.7073 134.146 51.7073C137.11 51.7073 139.512 54.1097 139.512 57.0732V80.4878H166.341C169.305 80.4878 171.707 82.8902 171.707 85.8537C171.707 88.8171 169.305 91.2195 166.341 91.2195H78.0488V148.293H160.976V124.39H105.366C102.402 124.39 100 121.988 100 119.024C100 116.061 102.402 113.659 105.366 113.659H166.829C169.523 113.659 171.707 115.843 171.707 118.537V154.146C171.707 156.84 169.523 159.024 166.829 159.024H139.512V182.927C139.512 185.89 137.11 188.293 134.146 188.293C131.183 188.293 128.78 185.89 128.78 182.927V159.024H110.732V182.927C110.732 185.89 108.329 188.293 105.366 188.293C102.402 188.293 100 185.89 100 182.927V159.024H72.1951C69.5011 159.024 67.3171 156.84 67.3171 154.146V85.3659C67.3171 82.6718 69.5011 80.4878 72.1951 80.4878H100V57.0732C100 54.1097 102.402 51.7073 105.366 51.7073Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 30.7317C70.6985 30.7317 30.7317 70.6985 30.7317 120C30.7317 169.302 70.6985 209.268 120 209.268C169.302 209.268 209.268 169.302 209.268 120C209.268 70.6985 169.302 30.7317 120 30.7317ZM20 120C20 64.7715 64.7715 20 120 20C175.228 20 220 64.7715 220 120C220 175.228 175.228 220 120 220C64.7715 220 20 175.228 20 120Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_21",
    x1: 0,
    y1: 0,
    x2: 240,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B78F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D28B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmt);
export default __webpack_public_path__ + "static/media/gmt.5f08443dcac3528af3e413e560e5c89e.svg";
export { ForwardRef as ReactComponent };